import { combineReducers } from 'redux';
import find from 'lodash/fp/find';
import reject from 'lodash/fp/reject';
import { pipe, append, propOr } from 'ramda';
import {
  FETCH_TIMER_STATE,
  START_TIMER,
  STOP_TIMER,
  SET_TIME_TRACKING_BARBERS,
  UPDATE_BARBER_TIME_TRACKING,
  REMOVE_BARBER_TIME_TRACKING,
  TOGGLE_TIMER,
  ADD_BARBER_TRACK_TIME,
  SYNC_BARBER_TRACK_TIME,
} from './constants';

const activeProp = propOr(false, 'active');

const activeTimer = (state = false, action) => {
  switch (action.type) {
    case FETCH_TIMER_STATE:
    case STOP_TIMER:
    case START_TIMER:
      return activeProp(action.payload);
    case TOGGLE_TIMER:
      return !state;
    default:
      return state;
  }
};

const fetchedTimer = (state = false, action) => {
  switch (action.type) {
    case FETCH_TIMER_STATE:
      return true;
    default:
      return state;
  }
};

const modalSuppresed = (state = false, action) => {
  switch (action.type) {
    case STOP_TIMER:
    case START_TIMER:
      return true;
    default:
      return state;
  }
};

const barbers = (state = {}, { type, payload }) => {
  switch (type) {
    case SET_TIME_TRACKING_BARBERS:
      return payload || {};
    case ADD_BARBER_TRACK_TIME: {
      const oldEntries = state[payload.barberId] || [];
      const newEntries = [...oldEntries, payload];
      return {
        ...state,
        [payload.barberId]: newEntries,
      };
    }
    case UPDATE_BARBER_TIME_TRACKING: {
      const oldEntries = state[payload.barberId] || [];
      const entry = find({ id: payload.id }, oldEntries);
      let newEntries;
      if (entry) {
        newEntries = [...reject({ id: payload.id }, oldEntries), payload];
      } else {
        newEntries = [...oldEntries, payload];
      }
      return {
        ...state,
        [payload.barberId]: newEntries,
      };
    }
    case REMOVE_BARBER_TIME_TRACKING: {
      const barberEntries = state[payload.barberId] || [];
      return {
        ...state,
        [payload.barberId]: reject({ id: payload.id }, barberEntries),
      };
    }
    case SYNC_BARBER_TRACK_TIME: {
      const entries = state[payload.ownerId] || [];
      return {
        ...state,
        [payload.ownerId]: pipe(
          reject({ id: payload.timeTrackEntry.id }),
          append(payload.timeTrackEntry),
        )(entries),
      };
    }
    default:
      return state;
  }
};

export default combineReducers({
  fetchedTimer,
  activeTimer,
  modalSuppresed,
  barbers,
});
